{
  "documentType": {
    "planning": "plan",
    "event": "hendelse",
    "assignment": "oppdrag",
    "article": "artikkel",
    "flash": "Flash",
    "quickArticle": "hurtigartikkel",
    "factbox": "Faktaboks"
  },
  "labels": {
    "newsvalue": "Nyhetsverdi",
    "section": "Kategori",
    "assignee": "Oppdragstaker",
    "assignmentType": "Oppdragstype",
    "title": "Tittel",
    "time": "Tid",
    "status": "Status",
    "type": "Type",
    "organiser": "Arrangør",
    "category": "Emne",
    "action": "Action",
    "story": "Story",
    "showOlder": "Vis eldre",
    "slugline": "Slugg"
  },
  "status": {
    "draft": "Utkast",
    "created": "Opprettet",
    "internal": "Intern",
    "approved": "Godkjent",
    "usable": "Publisert",
    "unpublished": "Avpublisert",
    "done": "Klar",
    "used": "Brukt",
    "print_done": "Klar",
    "needs_proofreading": "Klar for korrektur",
    "withheld": "Planlagt",
    "cancelled": "Kastet",
    "changed": "Endret",
    "moved": "flyttet",
    "todo": "Å gjøre",
    "started": "Startet",
    "public": "Offentlig",
    "sent": "Sendt",
    "typeApproved": "{{type, capitalize}} godkjent",
    "typeDone": "{{type, capitalize}} klar",
    "typeSaved": "{{type, capitalize}} lagret",
    "typeSent": "{{type, capitalize}} sendt",
    "typePublished": "{{type, capitalize}} publisert"
  },
  "timeSlots": {
    "morning": "Natt",
    "forenoon": "Morgen",
    "afternoon": "Ettermiddag",
    "evening": "Kveld",
    "fullday": "Hel dag"
  }
}
